import React, { use, useEffect, useState } from 'react'
import Breadcrums from '../Components/common/Breadcrums'
import { useParams } from 'react-router-dom'
import { Getdata } from '../helpers/api.service'
import dayjs from 'dayjs'

const NewsDetail = () => {
    const params = useParams()
    const [data, setData] = useState({})
    const [loaded, setLoading] = useState(true)
    const [selectedImage, setSelectedImage] = useState(null);

    const fetchData = () => {
        Getdata(process.env.REACT_APP_URL + `/front/news/show/${process.env.REACT_APP_SUBDOMAIN}${params.title}`)
            .then((res) => {
                console.log("News API response:", res);
                if (res?.data) {
                    setData(res.data);
                    if (res.data.image) {
                        setSelectedImage(res.data.image)
                    }
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching news:", err);
                setLoading(false);
            });
    }

    useEffect(() => {
        fetchData()
    }, [])


    return (
        <>
            <div className='max-w-7xl mx-3 sm:mx-auto text-left'>
                <div className="text-start max-w-7xl mx-auto font-medium mt-10 mb-5">
                    <Breadcrums pages={[{ title: "News", link: "news" }, { title: params.title }]} />
                </div>
                <div className="mx-1 sm:mx-auto">
                    {selectedImage && (
                        <div className="mb-4 w-full h-[220px] sm:h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden rounded-lg">
                            <img
                                src={selectedImage}
                                alt="Selected"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    )}
                    <div className="  relative flex justify-between text-gray-800   mx-auto">
                        <div>
                            <h3 className="text-2xl font-semibold my-3">
                                {data.title}
                            </h3>
                            <h3 className="text-sm text-gray-400 font-normal mb-2">
                                {dayjs(data.createdAt).format("DD MMM YYYY")}
                            </h3>


                            <div dangerouslySetInnerHTML={{ __html: data.description }} />


                        </div>

                    </div>


                </div>


            </div>
        </>
    )
}

export default NewsDetail